import { required, minLength, maxLength, email } from '@vuelidate/validators'

export default (modal) => {
    const rules = {
        name: {
            required,
            minLength: minLength(2),
            maxLength: maxLength(100),
        },
        country_id: {
            required,
        },
        street: {
            maxLength: maxLength(200),
        },
        postal_code: {
            maxLength: maxLength(32),
        },
        city: {
            minLength: minLength(2),
            maxLength: maxLength(100),
        },
        vat_identification_number: {
            maxLength: maxLength(25),
        },
        company_registration_number: {
            maxLength: maxLength(50),
        },
        contact_person: {
            maxLength: maxLength(100),
        },
        contact_email: {
            email,
        },
        invoice_email: { email },
        maintenance_email: { email },
        phone: {},
    }

    if (!modal) {
        rules.name.required = required
    }

    return rules
}
